<template>
  <div class="wrap">
    <div class="itemOne dn-content-bg">
      <!-- <el-tree
            ref="tabtree"
            style="padding-top: 10px;"
            :data="Treedata"
            node-key="id"
            :highlight-current="true"
            :default-expand-all="true"
            :expand-on-click-node="false"
            @node-click="handleCurrentChange1"
            empty-text="该公司暂无组织架构"
        >
            <span class="custom-tree-node" slot-scope="{ node, data }">
            <span>{{ node.data.name }}</span>
            </span>
        </el-tree> -->
      <el-tree
        :data="Treedata"
        ref="tabtree"
        class="tree-line"
        node-key="id"
        :highlight-current="true"
        :default-expand-all="true"
        :expand-on-click-node="false"
        @node-click="handleCurrentChange1"
      >
        <!-- :check-strictly="!checkStrictly" -->
        <span class="span-ellipsis" slot-scope="{ node, data }">
          <span :node="node" :title="data.measureName">{{ data.name }}</span>
        </span>
      </el-tree>
    </div>
    <div class="itemOneNew dn-content-bg">
      <div
        v-for="(item, index) in leftData"
        :key="index"
        :class="isIndex == index ? 'item btn' : 'item'"
        @click="bindClassItem(item, index)"
      >
        <div class="item-name">{{ item.name }}({{ item.measures.length }})</div>
        <!-- <div class="circular"></div> -->
      </div>
    </div>
  </div>
</template>

<script>
import {
  findDataByParam,
  dateToColumns,
  toPage,
  exportExcel,
} from "@/utils/index.js";
import dateTool from "@/utils/dateTool";
import api from "../../../../../common/api/index";
import socket from "@/utils/websocket.js"; // 组件
export default {
  data() {
    return {
      companyId: 0,
      enumData: [],
      classMeasuresData: [],
      measureExpressionData: [],
      leftData: [],
      wsPoints: [],
      isIndex: 0,
      enumClass: "",
      Treedata: [],
      selectedDate: null,
      selectedMeasure: null,
      meausreItem: null,
    };
  },
  // el 被新创建的 vm.$el 替换，并挂载到实例上去之后调用该钩子。
  mounted() {
    let vm = this;
    vm.$eventBus.$on("changeCompanyId", (companyId) => {
      vm.companyId = companyId;
      vm.init(this.enumClass);
    });
    api.frontEndPageCustomParam
      .getMyFrontEndPageCustomParam(
        vm.$store.state.user.currentCompanyId,
        "/nygl/equipmentgl",
        null
      )
      .then((res) => {
        res.data.forEach((item) => {
          if (item.param == "enumClass") {
            vm.enumClass = item.value;
          }
        });
        vm.init(vm.enumClass);
        vm.getData();
      });
  },
  created() {
    this.companyId = this.$store.state.user.currentCompanyId;
  },
  methods: {
    init(enumClass) {
      let vm = this;
      api.enumClass
        .getSubEnumClasses2(enumClass, 1, vm.$store.state.user.currentCompanyId)
        .then((res) => {
          let enumData = res.data;
          enumData.splice(0, 1);
          vm.enumData = enumData;
          console.log(
            "🚀 ~ file: deviceList.vue ~ line 111 ~ .then ~ enumData",
            enumData
          );
          //生成从枚举类中查询测量点的参数
          let classes = [];
          for (let i = 0; i < enumData.length; i++) {
            classes.push(enumData[i].name);
          }
          api.enumClass
            .getMeasuresFromEnumClasses2(
              classes,
              vm.$store.state.user.currentCompanyId
            )
            .then((resclassMeasures) => {
              vm.classMeasuresData = resclassMeasures.data;
              vm.handleData(vm.classMeasuresData);
            });
        });
    },
    getData() {
      //获取树节点
      let vm = this;
      vm.$api.orgStructNode
        .getORGStructNodes(vm.$store.state.user.currentCompanyId)
        .then((res) => {
          vm.Treedata = vm.toTree(JSON.parse(JSON.stringify(res.data)), 0);
          vm.$nextTick(() => {
            vm.$refs.tabtree.setCurrentKey(vm.Treedata[0].id);
            vm.selectedMeasure = vm.Treedata[0];
          });
        })
        .catch((error) => {});
    },
    //将扁平化数组转化为tree结构
    toTree(list, parId) {
      let len = list.length;
      function loop(parId) {
        let res = [];
        for (let i = 0; i < len; i++) {
          let item = list[i];
          if (item.parentId == parId) {
            item.children = loop(item.id);
            res.push(item);
          }
        }
        return res;
      }
      return loop(parId);
    },
    /*树点击 */
    handleCurrentChange1(row) {
      let vm = this;
      if (row) {
        vm.selectedMeasure = row;
        vm.matchData();
      }
    },
    /* 对子节进行处理 */
    matchData() {
      let vm = this;
      /* 顶级节点时走枚举档案 ，子节点走组织架构接口 */
      if (vm.selectedMeasure.parentId == "0") {
        vm.handleData(vm.classMeasuresData);
      } else {
        vm.$api.measure
          .getMeasureInfosByOrgId(vm.selectedMeasure.id, vm.enumClass)
          .then((resOne) => {
            vm.handleData(resOne.data);
          });
      }
    },
    /*classData 枚举数据  */
    handleData(classData) {
      let vm = this;
      let leftData = [];
      for (let i = 0; i < vm.enumData.length; i++) {
        let item = {};
        item.name = vm.enumData[i].displayName;
        let ids = [];
        let measureData = [];
        const data = classData.find((it) => it.classId === vm.enumData[i].id);
        if (data && data.measureList.length) {
          ids = data.measureList.map((it) => it.id);
          measureData = data.measureList;
        }
        item.measures = ids;
        item.measureData = measureData;
        item.state = 1; //  1代表正常  2代表异常
        /* 计量点为空则不需push了 */
        if (ids.length != 0) {
          leftData.push(item);
        }
      }
      vm.leftData = leftData;
      vm.bindClassItem(leftData[vm.isIndex], vm.isIndex);
    },
    /* 左边列表点击 */
    bindClassItem(item, index) {
      let vm = this;
      vm.isIndex = index;
      vm.$emit("bindClassItem", item, vm.enumClass, vm.selectedMeasure);
    },
  },
};
</script>

<style lang="scss" scoped>
.wrap {
  //   background: #ffffff;
  color: #000;
  width: 100%;
  height: 100%;
  display: flex;
}
.item {
  display: flex;
  padding: 10px;
  border: 1px solid #f5f5f5;
  //   margin-top: 10px;
  .item-name {
    flex: 1;
    text-align: left;
  }
  .circular {
    width: 20px;
    height: 20px;
    background: #161dea;
    border-radius: 100%;
  }
}
.itemOne {
  width: 240px;
  min-width: 200px;
  margin-right: 14px;
  padding: 10px;
  box-sizing: border-box;
}
.itemOneNew {
  width: 200px;
  min-width: 200px;
  margin-right: 14px;
  padding: 10px;
  box-sizing: border-box;
}
.btn {
  background: #5fa4e8;
  color: #fff !important;
}
</style>
